<template>
  <div
    v-if="value"
    class="tutorial-container"
    @click.stop="bindCatch"
    @touchmove="bindTouchMove"
    :style="{ zIndex: defaultZindex + zIndex }"
  >
    <div
      class="tip-circle"
      :class="{
        'circle-top': direction == 'bottom',
        'circle-bottom': direction == 'top'
      }"
      :style="{
        left: position.x + 'px',
        top: position.y + 'px',
        opacity: showTutorail ? 1 : 0
      }"
    >
      <div
        class="tip-content"
        ref="tipcontent"
        :class="{
          'content-top': direction == 'top',
          'content-bottom': direction == 'bottom'
        }"
        :style="{
          paddingLeft: image ? imageObj.width + imageObj.left + 'px' : '14px',
          transform: 'translate(' + textTransform + '%, 0%)'
        }"
      >
        <div
          class="tip-text"
          :style="{ textAlign: options.textAlign || 'left' }"
          v-html="options.text || ''"
        ></div>
        <img
          class="tip-image"
          v-if="image"
          :style="{
            left: imageObj.left + 'px',
            width: imageObj.width + 'px',
            height: imageObj.height + 'px'
          }"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8e599953f9d7f084fefb1ea9c9769a3c.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    image: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 100
    },
    options: {
      type: Object,
      default: () => {
        return {}
      }
    },
    //元素id
    id: {
      type: String,
      default: 'clock-btn'
    },
    top: {
      type: Number,
      default: 5
    },
    left: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      contentWidth: 268,
      defaultZindex: 2000,
      screenWidth: 0,
      screenHeight: 0,
      textTransform: -50,
      position: {
        x: 0,
        y: 0
      },
      imageObj: {
        width: 80,
        height: 75,
        left: -30
      },
      showTutorail: false
    }
  },
  computed: {
    direction() {
      return (this.options && this.options.direction) || 'bottom'
    }
  },
  watch: {
    options() {
      this.initPostion()
    },
    value() {
      this.initPostion()
    }
  },
  mounted() {
    this.screenWidth = document.body.clientWidth
    this.screenHeight = document.body.clientHeight
    this.initPostion()
  },
  methods: {
    initPostion() {
      if (!this.options || !this.options.id) {
        return
      }
      let id = this.options.id
      if (id) {
        let dom = document.getElementById(id)
        if (!dom) {
          return
        }
        let defaultLeft = 50
        let defaultTop = 0
        let left = dom.getBoundingClientRect().left
        let top = dom.getBoundingClientRect().top
        let width = dom.offsetWidth
        let height = dom.offsetHeight
        let position = {}
        position.x = left + width * ((this.options.left || defaultLeft) / 100)
        position.y = top + height * ((this.options.top || defaultTop) / 100)
        if (position.y < 0) {
          position.y = 0
        }
        if (position.y > this.screenHeight) {
          position.y = this.screenHeight
        }
        this.position = position
        this.computeTransform(this.position)
        this.showTutorail = true
      }
    },

    computeTransform(position) {
      console.log(position)
      this.contentWidth =
        (this.$refs.tipcontent && this.$refs.tipcontent.clientWidth) ||
        this.contentWidth
      let screenWidth = this.screenWidth
      let space = 2
      let res = -50
      console.log(this.contentWidth)
      if (position.x <= this.contentWidth / 2) {
        //如果靠左边遮挡
        console.log('靠左')
        res =
          -50 +
          space +
          ((this.contentWidth / 2 - position.x + this.imageObj.width / 2) /
            this.contentWidth) *
            100
      } else if (screenWidth - position.x <= this.contentWidth / 2) {
        //靠右边遮挡
        console.log('靠右')
        res =
          (-(this.contentWidth / 2 - (screenWidth - position.x)) /
            this.contentWidth) *
            100 -
          (this.image ? 50 : 42) -
          space
      }
      console.log(res)
      this.textTransform = res
    },
    bindTouchMove(e) {
      e.preventDefault()
    },
    bindCatch() {
      this.showTutorail = false
      setTimeout(() => {
        this.$emit('click')
      }, 400)
    },
    bindShow() {
      this.$emit('input', true)
    },
    bindHide() {
      this.$emit('input', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.tutorial-container {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1;
  .tip-circle {
    opacity: 1;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    width: 0;
    height: 0;
    box-sizing: border-box;
    transition: opacity 0.4s ease;
  }
  .tip-content {
    position: absolute;
    // max-width: 211px;
    width: auto;
    background: #6e44ff;
    border-radius: 20px;
    padding: 10px 14px;
    padding-left: 61px;
    box-sizing: border-box;
    box-shadow: 0px 4px 6px 0px rgba(49, 6, 201, 0.3);
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 17px;
    text-align: center;
    .tip-text {
      white-space: nowrap;
      min-width: 90px;
      display: inline-block;
      text-align: left;
    }
    .tip-image {
      width: 81px;
      position: absolute;
      left: -9%;
      bottom: 0px;
      object-fit: contain;
    }
  }
  .content-top {
    bottom: 8px;
  }
  .content-bottom {
    top: 8px;
  }
  .circle-top {
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 10px solid rgba(110, 68, 255, 1);
  }
  .circle-bottom {
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 10px solid rgba(110, 68, 255, 1);
  }
}
.fade-active {
  animation: myFade 0.6s ease;
}
.fade-leave {
  animation: myFadeleave 0.3s ease;
}
@keyframes myFade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes myFadeleave {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
